import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const OptionsContainer = styled(Flex)`
  flex: 1;
  flex-direction: column;

  overflow-y: auto;
  overflow-x: hidden;

  border-top: 1px solid ${toColorString(color.opacity.charcoal15)};

  max-height: ${rem(spacing.base * 15.8)};

  & ul {
    overflow: unset;
  }
`;
